import * as Web3 from 'web3';
var promisify = require('tiny-promisify');

import { SignatureUtils } from '../utils/signature_utils';

import { ECDSASignature } from '../types';

export class SignerAPI {
    private web3: Web3;

    constructor(web3: Web3) {
        this.web3 = web3;
    }

    public async signPayloadWithAddress(
        payload: string,
        address: string,
        withPrefix: boolean
    ): Promise<ECDSASignature> {
        const signPromise = promisify(this.web3.eth.sign);

        if (withPrefix) {
            payload = SignatureUtils.addPersonalMessagePrefix(payload);
        }

        try {
            const rawSignatureHex = await signPromise(address, payload, { from: address });
            return SignatureUtils.parseSignatureHexAsRSV(rawSignatureHex);
        } catch (e) {
            console.log('error', e);
            throw e;
        }
    }
}
